import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiClock,FiUsers,FiShield,FiPhone}=FiIcons;

const ClosingSection=()=> {
const whatsappUrl="https://wa.me/5214775954969?text=Reservar%20mi%20cupo%20ahora";
const whatsappContactUrl="https://wa.me/5214775954969?text=Tengo%20una%20pregunta%20sobre%20la%20modernización%20de%20mi%20restaurante";

return ( 
<section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white"> 
<div className="container mx-auto px-4"> 
{/* Final CTA */} 
{/* Contact Information */} 
<motion.div className="border-t border-gray-700 pt-12 text-center" initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} > 
<h4 className="text-2xl font-bold mb-6">¿Tienes preguntas?</h4> 
<div className="flex justify-center items-center gap-6"> 
<a href={whatsappContactUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-green-400 transition-colors duration-300"> 
<SafeIcon icon={FiPhone} className="text-xl text-green-400" /> <span>+52 (477) 179 6038</span> </a> </div> 
<p className="mt-8 text-gray-400"> © 2025 Ticket Factura - Expertos en Facturación Electrónica para Restaurantes </p> 
</motion.div> 
</div> 
</section> 
);};
export default ClosingSection;